<div class="page">
    <app-header [profile]="profile"></app-header>
    <app-sidebar appHoverEffectSidebar></app-sidebar>
    <!-- Start::app-content -->
    <div class="main-content app-content" (click)="clickOnBody()">
        <div class="container-fluid full-screen">
            <!-- Page Header -->
            <app-page-header></app-page-header>
            <!-- Page Header Close -->
            <router-outlet></router-outlet>
        </div>
    </div>
    <app-footer></app-footer>

    <app-tab-to-top></app-tab-to-top>
</div>
<div id="responsive-overlay" (click)="clearToggle()"></div>
